import { createContext, useContext, ReactNode } from "react"

type MobileNavContextType = {
    openMobileNav: () => void
}

const MobileNavContext = createContext<MobileNavContextType | undefined>(undefined)

export function MobileNavProvider({ children, openMobileNav }: { children: ReactNode; openMobileNav: () => void }) {
    return <MobileNavContext.Provider value={{ openMobileNav }}>{children}</MobileNavContext.Provider>
}

export function useMobileNav() {
    const context = useContext(MobileNavContext)
    if (!context) {
        throw new Error("useMobileNav must be used within MobileNavProvider")
    }
    return context
}

